import { checkIfNodeHaveText } from "utils/message";

const MEDIA_TYPES = new Set([
  "image",
  "video",
  "canva",
  "youtube",
  "vimeo",
  "embed",
  "media",
  "file",
  "attachment",
  "file-upload",
  "media-embed",
]);

export function canManageMagazine(
  user?: {
    isi?: boolean;
    systemRole?: string;
    magazineAdmin?: boolean;
  } | null
) {
  return Boolean(
    user?.isi ||
      user?.systemRole === "ADMIN" ||
      user?.systemRole === "LEADER" ||
      user?.magazineAdmin
  );
}

export function resolveMagazineName(
  vendor?: { magazineName?: string | null } | null,
  fallback = "Magazine"
) {
  const trimmed = vendor?.magazineName?.trim();
  return trimmed || fallback;
}

export function hasMagazineCanvasEmbed(value?: string | null) {
  if (!value?.trim()) return false;

  try {
    const blocks = JSON.parse(value);
    if (Array.isArray(blocks)) {
      return checkIfNodeHaveText(blocks);
    }
  } catch {
    return value.trim().length > 0;
  }

  return false;
}

export function magazineHasContent(edition?: {
  canvasEmbed?: string | null;
  previewImage?: string | null;
}) {
  return Boolean(edition?.previewImage) || hasMagazineCanvasEmbed(edition?.canvasEmbed);
}

export function extractMagazineMediaTypes(canvasEmbed?: string | null) {
  if (!canvasEmbed?.trim()) return { hasCanvas: false, hasPreviewOnly: false };

  try {
    const nodes = JSON.parse(canvasEmbed);
    if (!Array.isArray(nodes)) {
      return { hasCanvas: false, hasPreviewOnly: false };
    }

    const hasCanvas = nodes.some((node: { type?: string }) =>
      MEDIA_TYPES.has(node?.type ?? "")
    );

    return { hasCanvas, hasPreviewOnly: false };
  } catch {
    return { hasCanvas: false, hasPreviewOnly: false };
  }
}
